export default __webpack_public_path__ + "static/media/ic_drivers_on.6e4f32df.svg";